angular.module("acl.visualizer.tabState", [
  "acl.common.asyncCallManager",
  "acl.common.event",
  "acl.visualizer.dataModel",
]);
